import { styled } from "@mui/material";

import twToCss from "utils/twToCssHelper";

export const Btn = styled("button")`
	${twToCss("relative w-full")};

	&:after {
		content: "";

		${twToCss("absolute top-0.5 left-0 w-full h-full rounded-[32px] bg-[#c16b1b]")};
		box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.98);
	}

	.button {
		${twToCss("relative rounded-[32px] w-full bg-yellow-350 p-[5px] z-[1]")};

		box-shadow: 0 1px 0 0 #fff1b5 inset;
	}

	.btn-content {
		${twToCss("w-full h-fit border-none rounded-[26px] p-px relative")};
		background: #b51717;
	}

	.btn-selector {
		${twToCss("rounded-[26px] flex-1 h-[50px] flex items-center justify-center gap-1")};

		background: linear-gradient(180deg, #f94830 0%, #ff9a6f 9%, #ff5c17 22%, #f21d13 42%, #820b06 88.5%, #a7130c 100%);
	}

	.text {
		${twToCss("font-mic text-[30px] text-yellow-350")};
		text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.6);
	}
`;
